// extracted by mini-css-extract-plugin
module.exports = {"heading":"Header_heading__fKu8x"};